import { render, staticRenderFns } from "./SubscriptionStatusBadge.vue?vue&type=template&id=278585b0&"
import script from "./SubscriptionStatusBadge.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports